import { select } from 'redux-saga/effects';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { PrescriptionValidationStepContainer } from '../../../../steps/PrescriptionValidationStep/PrescriptionValidationStepContainer.js';
import { isNewPrescriptionAndUpload } from '../../../../utils/is-new-prescription-upload.js';
import '../../../actions.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getIsExtraValidationStepEnabled, getPrescriptionType, getVerificationAllowed } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';

const prescriptionValidationStepBase = {
    onNext,
    stepStatus: (s)=>{
        /**
     * Page should only show when the customer chose to enter their prescription manually via our form ("NewPrescription").
     */ const isStepEnabled = getIsExtraValidationStepEnabled(s);
        const prescriptionType = getPrescriptionType(s);
        const isNewPrescription = CommerceToolsApi.isNewPrescription(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType);
        if (!isStepEnabled) {
            return 'hidden';
        }
        return isNewPrescription ? 'active' : 'skip';
    },
    view: PrescriptionValidationStepContainer
};
function* onNext() {
    const isVerificationAllowed = yield select(getVerificationAllowed);
    return !isVerificationAllowed;
}

export { prescriptionValidationStepBase };
//# sourceMappingURL=prescription-validation.js.map
